<!--
  Bulle WhatsApp flottante (app) — lien direct vers le WhatsApp de Jim.
  Port Tailwind du widget de la landing (weplaybig/website : src/includes/_whatsapp-widget.ejs).
  Montée dans layouts/default.vue uniquement → visible dans l'app connectée.
  z-50 : passe DERRIÈRE le backdrop des modals (BModal = z-index 100), donc floutée/estompée
  pendant la création d'une mission/expérience. La carte-étiquette (gauche) est masquée sous sm.
  Anneau de pulsation + transitions neutralisés sous prefers-reduced-motion (voir <style> scoped).
  Masqué sur les pages qui déclarent `definePageMeta({ hideWhatsappWidget: true })` (#251 :
  évite le chevauchement avec une barre d'action fixe en bas, ex. "Trouver un expert").
-->
<template>
  <a
    v-if="!route.meta.hideWhatsappWidget"
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    :aria-label="t('whatsapp.ariaLabel')"
    class="wa-fab group fixed bottom-6 right-6 z-50 flex items-center gap-3"
  >
    <span
      class="wa-fab__card hidden items-center gap-3 rounded-2xl bg-white py-2.5 pl-4 pr-4 shadow-lg shadow-black/25 ring-1 ring-black/5 transition-transform duration-200 group-hover:-translate-x-0.5 sm:flex"
    >
      <span class="flex flex-col leading-tight">
        <span class="text-[11px] font-medium uppercase tracking-wide text-gray-500">{{ t('whatsapp.kicker') }}</span>
        <span class="text-sm font-semibold text-gray-900">{{ t('whatsapp.label') }}</span>
      </span>
    </span>
    <span
      class="wa-fab__btn relative flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/25 transition-transform duration-200 group-hover:scale-110"
    >
      <span class="wa-fab__pulse absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60" aria-hidden="true" />
      <svg class="relative h-7 w-7" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    </span>
  </a>
</template>

<script setup lang="ts">
const { t } = useI18n();
const route = useRoute();

// Numéro direct de Jim, identique à la landing (pas d'indirection config).
const href = "https://wa.me/33615772609";
</script>

<style scoped>
/* Anneau de pulsation derrière le FAB. État de repos = bouton visible ; l'anneau
   n'ajoute que du mouvement. Neutralisé sous prefers-reduced-motion. */
.wa-fab__pulse {
  animation: wa-pulse 2.4s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes wa-pulse {
  0% {
    transform: scale(1);
    opacity: 0.55;
  }
  70%,
  100% {
    transform: scale(1.9);
    opacity: 0;
  }
}
.wa-fab:focus-visible {
  outline: none;
}
.wa-fab:focus-visible .wa-fab__btn {
  outline: 3px solid #25d366;
  outline-offset: 3px;
}
@media (prefers-reduced-motion: reduce) {
  .wa-fab__pulse {
    animation: none;
    opacity: 0;
  }
  .wa-fab__card,
  .wa-fab__btn {
    transition: none;
  }
}
</style>
